import React from 'react';
import { shallow, ShallowWrapper } from 'enzyme';
import AboutYourselfContainer from './AboutYourselfContainer';

const createProps = () => ({});

let props;
let wrapped: ShallowWrapper;

describe('Your description here', () => {
  beforeEach(() => {
    props = createProps();
    wrapped = shallow(<AboutYourselfContainer {...props} />);
  });

  it('shallow renders without crashing', () => {
    expect(wrapped.exists()).toBe(true);
  });
});

test.todo('add more tests');
